/* global moment: false */
import { httpGet } from '../utils'

export default {
  getStat (cb) {
    /**
     * @todo 临时加上 min_time，还是按照套路走
     */
    httpGet(`/api/dashboard/statistics?min_time=${moment().subtract(6, 'day').startOf('day').unix()}`, cb)
  },
  getNews (cb, { page, perPage }) {
    // httpGet(`/api/dashboard/news?page=${page}&per_page=${perPage}`, cb)
    httpGet(`/api/dashboard/news`, cb)
    /*
    setTimeout(() => {
      cb.success({
        body: [{
          'id': 'xxx',
          'title': '5656',
          'news_type': 'activity_signup',
          'count': 10,
          'last_sign_time': 121343434
        }, {
          'id': 'yyy',
          'title': '8989',
          'news_type': 'activity_signin',
          'count': 100,
          'last_sign_time': 121343434
        }]
      })
    }, 100)
    */
  },
  getUserGuideGift (cb) {
    httpGet(`/api/team/check_team_info`, cb)
  }
}



// WEBPACK FOOTER //
// ./src/api/lxm/dashboard.js